import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { jkSingleComponent, } from 'jk-advcom';
import { StkmjService, templateUrlConfigStk } from './../_service_stk';
//import { Stkpi17DetailComponent } from './stkpi17-detailPkg.component';
import { StkmjEditComponent, } from './../_edit_stk';
import { PageKind, UiModeType } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-stkpi17',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    //Stkpi17DetailComponent,
    //StkmjEditComponent,
  ],
  //templateUrl: templateUrlConfigStk.stkpi17,
  template: ``,
  styleUrls: [],
})
export class Stkpi17PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi17';
  constructor() {
    super();
    this.srv = new StkmjService();
    this.uiMode = UiModeType.dialog;
    this.title = '選股中心建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'MJ002', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };
    this.qbeConfig.addField = 'MJ003,MJ005,MJ007';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = StkmjEditComponent;


    this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */


}
